<template>
    <div class="languageWrap">
		<div class="back" @click="jumpBack">
			<img src="../assets/img/back.png"/>
		</div>
		<div class="logo">
			<img src="../assets/img/logo.png"/>
		</div>
		<div class="title" v-html='$t("language.title")'></div>
		<div class="language_bj">
			<div class="selectLanguage" @click="openValue">
				<input type="text" readonly class="langSelect" v-model="langValue" />	
			</div>
			<!--ul li模拟下拉菜单-->
			<div class="list" v-show="show">
				<ul>
					<li v-for="(item,index) in langOptions" :key="index"
						@click="getvalue(index,item);changeLanguage(item.value)"
					>{{item.lang}}</li>
				</ul>	
			</div>			
		</div>
		<div class="okButton" @click="$router.push('/');">
			<img src="../assets/img/ok.png"/>
		</div>
    </div>
</template>

<script>
	export default {
		data() {
			return {
				langOptions: [
					{ value: "zh", lang: "中文简体" },
					{ value: "en", lang: "English" },
					{ value: "hk", lang: "中文繁體" },
				],
				langValue: this.$t('language.lang'),
				show: false,
			};
		},
		created() {
			
		},
		methods: {
			jumpBack() {
				this.$router.push("/");
			},
			changeLanguage(lang) {
				this.$i18n.locale = lang;
				sessionStorage.setItem('locale',lang);
			},
			getvalue(index, item) {
				this.langValue = item.lang;
				this.show = false;
			},
			openValue() {
				this.show = !this.show;
			},
		}
	};
</script>

<style scoped>
	.languageWrap {
		height: 100%;
		background: #D4B48C;
		overflow: hidden;
	}
	.back {
		color: #fff;
		width: 23px;
		height: 40px;
		position: absolute;
		top: 54px;
		left: 30px;
	}
	.back img{
		width: 23px;
		height: 40px;
	}
	.logo img {
		width: 300px;
		height: 202px;
		display: block;
		margin: 89px auto 40px auto;
	}
	.title {
		text-align: center;
		font-size: 40px;
		color: #fff;
		margin-top: 40px;
	}
	.language_bj {
		width: 596px;
		height: 600px;
		/* background: url("../assets/img/language_bj.png") no-repeat center center; */
		background-size: cover;
		margin: 40px auto;
		position: relative;
		overflow: hidden;
	}

	/*选择语言框*/
	.selectLanguage {
		width: 460px;
		height: 80px;
		border-radius: 40px;
		margin-top: 60px;
		margin: 60px auto 0;
		background: #AA723C;
		border-radius: 40px;
		position: relative;
	}
	/*下拉箭头*/
	.selectLanguage::after {
		content: "";
		width: 33px;
		height: 19px;
		background: url("../assets/img/list.png") no-repeat center;
		background-size: cover;
		position: absolute;
		top: 31px;
		right: 39px;
		pointer-events: none;
	}
	/*input输入框*/
	.langSelect {
		width: 450px;
		height: 80px;
		border-radius: 40px;
		border: none;
		outline: none;
		background: transparent;
		color: #fff;
		font-size: 32px;
		padding-left: 20px;
	}

	ul {
		width: 440px;
		height: 300px;
		overflow: auto;
		overflow-x: hidden;
		margin-left: 80px;
		margin-top: 10px;	
		border-radius: 25px;
		box-shadow:0px 0px 15px rgba(0, 0, 0, .5);
		position: relative;
		background: #AA723C;
	}

	/*语言列表*/
	li {
		width: 460px;
		height: 70px;
		font-size: 30px;
		color: #fff;
		line-height: 80px;
		padding-left: 10px;
		border-bottom: 1px solid #b89574;
	}
	/* li:last-child{
		border-bottom: none;
	} */

	/*对号按钮*/
	.okButton {
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		width: 100%;
		bottom: 100px;
		left: 0;
	}
	.okButton img {
		width: 102px;
		height: 102px;
		border-radius: 50%;
		border: 2px solid #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Language.vue